import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LatLngLiteral } from '@agm/core';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PartnerSite } from 'src/app/assabil-kernel/models/entities/control-tables/partner-site-entity';
import { marker } from 'src/app/tools/models/entities/marker';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';


@Component({
  selector: 'partner-site-widget',
  templateUrl: './partner-site-widget.component.html',
  styleUrls: ['./partner-site-widget.component.scss']
})

export class PartnerSiteWidgetComponent extends BaseWidget {

  partnerSite: PartnerSite = new PartnerSite();

  
  constructor(
    protected masterDataService : MasterDataService,
    protected toastr            : ToastrService,
    protected leanUtilsService  : LeanUtilsService,
    protected router            : Router) {
      super(toastr, leanUtilsService);
  }

  //------------------------------------------------------
  setEntity(partnerSite: PartnerSite) {
    this.partnerSite = { ...partnerSite };
    this.buildPoints();
  }
  getEntity(){
    return this.partnerSite;
  }
  //------------------------------------------------------


  //------------------------------------------------------
  saveRow() : Promise<PartnerSite>{
    return this.masterDataService.partnerSiteSave(this.partnerSite);
  }
  //------------------------------------------------------






  onMapClick(point : LatLngLiteral){
    if (this.partnerSite.edit){
      this.partnerSite.latitude = point.lat;
      this.partnerSite.longitude = point.lng;
    }
  }

  points : marker[] = [];
  buildPoints(){
      let point : marker = {     
        lat: this.partnerSite.latitude,
        lng: this.partnerSite.longitude,
        label: this.partnerSite.name,
        draggable: false,
        iconUrl: 'http://maps.google.com/mapfiles/ms/icons/green.png'
      };
    
      this.points.push(point);
    }
}
